import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/lyft': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M0 81.1H77.8V289.8C77.8 322.9 92.8 342.6 105 350.8 92.3 361.9 53.8 371.7 24.8 348 7.8 334 0 310.7 0 289V81.1zM485.9 254.6V232.6H509.7V155.8H483.6C473.5 109.5 432.4 75.1 383.3 75.1 326.7 75.1 280.6 121.1 280.6 177.8V357C296.6 359.3 316 356.7 332.3 343 349.4 329 357.1 305.8 357.1 284V277.3H395.9V200.5H357.1V177.2C357.1 142.6 409.3 142.6 409.3 177.2V254.3C409.3 310.9 455.3 357 512 357V280.5C497.5 280.5 485.9 268.8 485.9 254.6zM191.6 155.6V268.6C191.6 284 167.8 284 167.8 268.6V155.6H91V288.3C91 312.1 99 342.3 136 352.2 173 362 194.2 341.6 194.2 341.6 192.1 355 179.7 364.9 159.3 366.9 143.8 368.5 124.1 363.3 114.3 359.1V429.4C139.4 436.9 165.8 439.2 191.9 434.1 239 425 268.7 385.7 268.7 333.3V155.1H191.6V155.6z'
      }
    ]
  }
})
